<template>
  <div
    class="inline-flex items-center gap-2 !font-medium text-neutral-100 text-title-3 md:!text-16 dark:text-white/90"
    :class="divClass"
  >
    <q-icon
      :class="iconClass"
      :name="icon"
      size="1.5rem"
      v-bind="iconProps"
    />
    <p>{{ text }}</p>
  </div>
</template>

<script setup>
defineProps({
  icon: String,
  text: String,
  divClass: String,
  iconClass: String,
  iconProps: Object,
})
</script>

<style lang="scss" scoped></style>
